import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gstar-country-home',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountryHomeComponent {}
